import { Injectable, inject } from '@angular/core';
import { HttpRequestDecorator } from '../triggerbee/http.request.decorator';
import { TriggerbeeApi } from '../triggerbee/triggerbee-api.enum';
import { IdentityParserService } from './identity-parser.service';
import { UserIdentity } from './user-identity';

@Injectable()
export class CurrentUserService {
  private readonly http = inject(HttpRequestDecorator);
  private readonly identityParser = inject(IdentityParserService);

  public async loadFromServer(): Promise<UserIdentity | undefined> {
    try {
      const baseUrl = this.http.getBaseUrl(TriggerbeeApi.Gateway);
      const response = await this.http.get(`${baseUrl}/authentication/current-user`).toPromise();
      if (!response) return undefined;
      return this.identityParser.transformToIdentity(response);
    } catch {
      return undefined;
    }
  }
}
